import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getOfficeUrl } from '../utils/utils';

export const useClientRedirect = () => {
  const { isAuthenticated } = useSelector(({ webmaster: { isAuthenticated } }) => ({
    isAuthenticated,
  }));

  useEffect(() => {
    if (isAuthenticated > 0) {
      window.location.href = getOfficeUrl();
    }
  }, [isAuthenticated]);
};
